import { render, staticRenderFns } from "./RemissionsView.vue?vue&type=template&id=70dcedf0"
import script from "./RemissionsView.vue?vue&type=script&lang=js"
export * from "./RemissionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports